// extracted by mini-css-extract-plugin
export default {"footer":"components-payment-modal-statement-of-account-module__footer"};